import React from "react"
import Helmet from "react-helmet"
import { css } from "@emotion/core"
import { useStaticQuery, Link, graphql } from "gatsby"

import { rhythm } from "../utils/typography"

import Header from "../components/header"
import Footer from "../components/footer"

export default ({ children }) => {
  if (typeof window !== "undefined") {
    // eslint-disable-next-line global-require
    require("smooth-scroll")('a[href*="#"]', {
      speed: 500,
      speedAsDuration: true,
    })
  }
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        min-height: 100%;
      `}
    >
      <Helmet>
        <title>Guides to the best SaaS tools — Satchel</title>
        <link rel="shortcut icon" type="image/png" href="/favicon.png" />
      </Helmet>
      <Header></Header>
      <div
        css={css`
          flex-grow: 1;
        `}
      >
        {children}
      </div>
      <Footer></Footer>
    </div>
  )
}
